<!-- file:///home/henry/Pictures/Screenshot%20from%202018-03-17%2023-26-19.png -->
<template>
<div>
</div>
</template>

<script>
export default {
  name: "Desktop",
  data() {}
}
</script>



// WEBPACK FOOTER //
// src/partials/Desktop.vue